import { BuildModuleParamsType } from 'types/api-internal';
import { SugarMoneyTransactionStatusResponseType } from 'types/common';

export const transactionsModule = ({ makeApiRequest }: BuildModuleParamsType) => ({
  checkStatus: async ({ signature }: { signature: string }) =>
    makeApiRequest<SugarMoneyTransactionStatusResponseType>({
      endpoint: 'transaction/status',
      options: { method: 'get' },
      searchParams: { signature },
    }),
});
